export const iconFontAwesomeCodingFileLines = (
	<i className="fa-solid fa-file-lines"></i>
);
